import RosterBackendService from './RosterBackendService';
import { BatchStep, BatchStepWithSort, SiteID, StepIdWithSort } from '@beable/roster-backend-client-v1';

async function siteBatchStepsSave(siteId: SiteID, batchSteps: StepIdWithSort[]): Promise<boolean> {
    const result = await RosterBackendService.siteBatchStepsSave({ siteId, batchSteps });
    if (result.isErr()) {
        return false
    }
    return result.value;
}

async function siteBatchStepsGet(siteId: SiteID): Promise<BatchStepWithSort[]> {
    const result = await RosterBackendService.siteBatchStepsGet({ siteId });
    if (result.isErr()) {
        return [];
    }
    return result.value.batchSteps;
}

async function batchStepsGet(): Promise<BatchStep[]> {
    const result = await RosterBackendService.batchStepsGet();
    if (result.isErr()) {
        return [];
    }
    return result.value.batchSteps;
}

export default {
    siteBatchStepsSave,
    siteBatchStepsGet,
    batchStepsGet
};
